export const APP_CONTAINER_ID = 'lithe-app';
export const APP_MODAL_ID = 'app-modal';

// Storage keys
export const APP_LANGAUGE_STORAGE_KEY = 'lithe-tutorial-lng';
export const APP_THEME_STORAGE_KEY = 'lithe-theme';

// State slices
export const APP_MODAL_SLICE = 'app-modal';
export const APP_GLOBAL_SLICE = 'app-global';
export const APP_TUTORIAL_SLICE = 'app-tutorial';
export const APP_DOCS_SLICE = 'app-docs';
export const APP_UI_SLICE = 'app-ui';
export const APP_DEMO_SLICE = 'app-demo';
export const APP_NEWSLETTER_SLICE = 'app-newsletter';
